

































































































































import PopupWrapper from '@/components/ui/PopupWrapper/index.vue';
import DefaultImage from '@/components/ui/product/DefaultImage/index.vue';
import Ingredient from '@/models/ingredient';
import IngredientsGroup from '@/models/ingredientGroup';
import OrderProduct from '@/models/orderProduct';
import Place from '@/models/place';
import TakeAway from '@/models/takeAway';
import cloneDeep from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import OneOfGroup from './components/OneOfGroup.vue';
import OptionalGroup from './components/OptionalGroup.vue';

@Component({
  name: 'OrderProductWithIngredientsEditPopup',
  components: {
    DefaultImage,
    OneOfGroup,
    OptionalGroup,
    PopupWrapper,
  },
})
export default class OrderProductWithIngredientsEditPopup extends Vue {
  @Prop({
    type: OrderProduct,
    required: true,
  })
  private initOrderProduct!: OrderProduct;

  private orderProduct: OrderProduct = cloneDeep(this.initOrderProduct);

  private get canIncrementProductCount(): boolean {
    return this.selectedPlace.settings.widget.maxProductCount > this.order.productsCount + this.orderProduct.count - this.initOrderProduct.count;
  }

  private get canIncrementIngredientCount(): boolean {
    return this.selectedPlace.settings.widget.maxIngredientCount > this.orderProduct.ingredientsCount;
  }

  private get isProductWasChange() {
    return !isEqual(this.initOrderProduct, this.orderProduct);
  }

  @State('selectedPlace', {
    namespace: 'place',
  })
  private selectedPlace!: Place;

  @State('order', {
    namespace: 'takeAway/order',
  })
  private order!: TakeAway;

  private incrementOrderProductIngredientCountByIngredient(ingredient: Ingredient) {
    if (this.canIncrementIngredientCount) {
      this.orderProduct.incrementOrderProductIngredientCountByIngredient(ingredient);
    }
  }

  private decrementOrderProductIngredientCountByIngredient(ingredient: Ingredient) {
    this.orderProduct.decrementOrderProductIngredientCountByIngredient(ingredient);
  }

  private selectOneOfIngredient(
    payload: { selectedIngredient: Ingredient, oldSelectedIngredient: Ingredient, group: IngredientsGroup },
  ) {
    this.orderProduct.selectOneOfIngredient(payload);
  }

  private changeOrderProductInOrder() {
    if (this.isProductWasChange) {
      this.changeOrderProductInOrderMutation({
        oldOrderProductHash: this.initOrderProduct.hash,
        newOrderProduct: this.orderProduct,
      });
      this.close();
    }
  }

  private incrementOrderProductCount() {
    if (this.canIncrementProductCount) {
      this.orderProduct.increment();
    }
  }

  private decrementOrderProductCount() {
    this.orderProduct.decrement();
  }

  private close() {
    this.$destroy();
  }

  @Mutation('changeOrderProductInOrder', {
    namespace: 'takeAway/order',
  })
  changeOrderProductInOrderMutation!: ({ oldOrderProductHash, newOrderProduct }: any) => void;
}
